import { render } from "./Samsung.vue?vue&type=template&id=1133e2a8&scoped=true"
import script from "./Samsung.vue?vue&type=script&lang=js"
export * from "./Samsung.vue?vue&type=script&lang=js"

import "./Samsung.vue?vue&type=style&index=0&id=1133e2a8&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1133e2a8"]])

export default __exports__